import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the vehicle tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['assets/findVehicleGroupsWidgetModule/get']
}

/**
 * Returns the sets of selected vehicles.
 *
 * @return Object
 */
export const selectedGroupsSets = () => {
  return store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets']
}

/**
 * Returns groups that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedGroups = (set) => {
  if (store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'].hasOwnProperty(set)) {
    return store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns group id's that are selected for the specified set.
 *
 * @param set String
 *
 * @return Array
 */
export const selectedGroupIds = (set) => {
  if (store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'].hasOwnProperty(set)) {
    const vehicleGroups = store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'][set]
    let results = []

    for (let key in vehicleGroups) {
      if (vehicleGroups.hasOwnProperty(key)) {
        results.push(vehicleGroups[key].id)
      }
    }

    return results
  } else {
    return []
  }
}

/**
 * Returns group names that are selected for the specified set.
 *
 * @param set String
 *
 * @return Array
 */
export const selectedGroupNames = (set) => {
  if (store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'].hasOwnProperty(set)) {
    const vehicleGroups = store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'][set]
    let results = []

    for (let key in vehicleGroups) {
      if (vehicleGroups.hasOwnProperty(key)) {
        results.push(vehicleGroups[key].name)
      }
    }

    return results
  } else {
    return []
  }
}

/**
 * Returns the first selected group in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedGroup = (set) => {
  if (store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'].hasOwnProperty(set)) {
    const groups = store.getters['assets/findVehicleGroupsWidgetModule/groupSelectionSets'][set]
    const groupIds = Object.keys(groups)
    if (groupIds.length > 0) {
      return groups[groupIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified vehicle is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedGroups(set).hasOwnProperty(id)
}

/**
 * Returns either a client object or null depending on whether
 * queries should be made by client.
 *
 * @return Object|null
 */
export const getClient = () => {
  return store.getters['assets/findVehicleGroupsWidgetModule/getClient']
}

/**
 * Load the status data of the vehicles being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('assets/findVehicleGroupsWidgetModule/query')
}

/**
 * Add a map or array of object vehicles that have been selected within
 * the specified set.
 *
 * @param set String
 * @param groups Array|Map
 */
export const addSelectedGroups = (set, groups) => {
  store.commit('assets/findVehicleGroupsWidgetModule/addSelectedGroups', { set, groups })
}

/**
 * Removes an array of vehicles from the set's list of selected vehicles.
 * The array must consist of the id's of the vehicles that are no
 * longer selected.
 *
 * @param set String
 * @param groups Array
 */
export const removeSelectedGroups = (set, groups) => {
  store.commit('assets/findVehicleGroupsWidgetModule/removeSelectedGroups', { set, groups })
}

/**
 * Clears all selected vehicles within a specified set.
 */
export const clearSelectedGroups = (set) => {
  store.commit('assets/findVehicleGroupsWidgetModule/clearSelectedGroups', set)
}

/**
 * Clears all selected vehicles.
 */
export const clearAllSelectedGroups = () => {
  store.commit('assets/findVehicleGroupsWidgetModule/clearAllSelectedGroups')
}

/**
 * Returns the selected vehicle count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedGroupCount = (set) => {
  return Object.keys(selectedGroups(set)).length
}

/**
 * Clears all vehicles from being tracked.
 */
export const purge = () => {
  store.commit('assets/findVehicleGroupsWidgetModule/purge')
}

/**
 * Sets the client for which the vehicles should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('assets/findVehicleGroupsWidgetModule/setClient', client)
}



// WEBPACK FOOTER //
// ./src/store/assets/vehicle-groups/findVehicleGroupsWidget.helpers.js